import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import '../pages/Login/Auth.css';

function PublicOnlyRoute() {
    const { t } = useTranslation('common');
    const { authInitializing, isAuthenticated } = useAuth();

    if (authInitializing) {
        return <Spin fullscreen size="large" tip={t('loading.session')} />;
    }

    if (isAuthenticated) {
        return <Navigate to="/home" replace />;
    }

    return (
        <div className="auth-shell">
            <Outlet />
        </div>
    );
}

export default PublicOnlyRoute;
